var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.dialogVisible,
      width: 600,
      footer: null,
      maskClosable: false
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("div", {
    staticClass: "titleBox"
  }, [_c("a-icon", {
    staticClass: "icon",
    attrs: {
      type: "close-circle"
    }
  }), _vm.type == 1 ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("无法删除")))]), _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("所选组件正在以下模版中使用，请取消后删除")))])]), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("示例:页面名称/页面类型")))]), _c("div", {
    staticClass: "listBox",
    staticStyle: {
      "margin-top": "5px"
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(_vm._s(item.name) + "/" + _vm._s(_vm.$t(item.type)))]);
  }), 0)]) : _vm.type == 3 || _vm.type == 6 || _vm.type == 7 ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("无法禁用")))]), _vm.type == 3 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("所选组件正在以下客户产品中使用，请取消后禁用")))]) : _vm.type == 6 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(" " + _vm._s(_vm.$t("当前商户号正在以下发布产品中使用，请禁用发布数据后操作")) + " ")]) : _vm.type == 7 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("当前产品正在以下客户应用中使用，请禁用发布数据后操作")))]) : _vm._e()]), _vm.type == 6 ? _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("示例:发布产品/发布客户")))]) : _vm.type == 7 ? _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.$t("示例:发布客户/发布应用")))]) : _vm._e(), _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm.type == 3 ? _c("div", [_vm._v(_vm._s(_vm.$t(item.name)))]) : _vm.type == 6 ? _c("div", [_vm._v(_vm._s(item.name) + "/" + _vm._s(item.customerName))]) : _vm.type == 7 ? _c("div", [_vm._v(_vm._s(item.customerName) + "/" + _vm._s(item.applicationName))]) : _vm._e()]);
  }), 0)]) : _vm.type == 2 || _vm.type == 4 || _vm.type == 5 ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("无法禁用")))]), _vm.type == 2 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("所选组件正在以下模版组中使用，请取消后禁用")))]) : _vm._e(), _vm.type == 4 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("所选数据源正在以下控件中使用，请取消后删除")))]) : _vm._e(), _vm.type == 5 ? _c("div", {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t("所选文件正在以下机构中使用，请取消后禁用")))]) : _vm._e()]), _c("div", {
    staticClass: "listBox"
  }, _vm._l(_vm.list, function (item, index) {
    return _c("div", {
      key: index
    }, [_vm._v(_vm._s(_vm.$t(item)))]);
  }), 0)]) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };